<template>
    <md-snackbar md-position="center" :md-duration="Infinity" :md-active="showGaPrompt" md-persistent>
        <span class="is-size-7">We use cookies to ensure you get the best experience on our app.</span>
        <md-button class="md-primary" @click="enableGA">
            <span class="has-text-weight-bold">OK</span>
        </md-button>
        <md-menu md-direction="top-start">
            <md-button md-menu-trigger class="md-icon-button md-dense md-accent">
                <md-icon class="is-size-6 has-text-grey">more_vert</md-icon>
            </md-button>
            <md-menu-content>
                <md-menu-item to="/terms">Privacy Policy</md-menu-item>
                <md-menu-item @click="showGaPrompt = false">Disable Tracking</md-menu-item>
                <md-menu-item></md-menu-item>
            </md-menu-content>
        </md-menu>
    </md-snackbar>
</template>

<script>
    import { bootstrap } from 'vue-gtag'

    export default {
        name: "gdpr-prompt",
        data() {
            return {
                showGaPrompt: false
            }
        },
        methods: {
            enableGA() {
                bootstrap(true).then(() => {
                    localStorage.gaEnable = true;
                    this.showGaPrompt = false
                })
            }
        },
        mounted() {
            if (localStorage.gaEnable) {
                this.enableGA()
            } else {
                this.showGaPrompt = true
            }
        }
    }
</script>

<style scoped>
</style>